var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgSlash = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M4.95033562,6.01099579 C3.57803827,7.6247457 2.75,9.7156735 2.75,12 C2.75,17.1086339 6.89136606,21.25 12,21.25 C14.2843265,21.25 16.3752543,20.4219617 17.9890042,19.0496644 L4.95033562,6.01099579 L4.95033562,6.01099579 Z M6.01099579,4.95033562 L19.0496644,17.9890042 C20.4219617,16.3752543 21.25,14.2843265 21.25,12 C21.25,6.89136606 17.1086339,2.75 12,2.75 C9.7156735,2.75 7.6247457,3.57803827 6.01099579,4.95033562 Z M12,22.75 C6.06293894,22.75 1.25,17.9370611 1.25,12 C1.25,6.06293894 6.06293894,1.25 12,1.25 C17.9370611,1.25 22.75,6.06293894 22.75,12 C22.75,17.9370611 17.9370611,22.75 12,22.75 Z"
  }));
};
export default SvgSlash;